import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { UserType } from '../../../types';
import { useAuthContext } from '../../../contexts/AuthContext';
import SwitchMobile from '../atomicDesignMobile/atoms/SwitchMobile';
import TextInputMobile from '../atomicDesignMobile/atoms/TextInputMobile';
import useLandingPageEmailParam from '../../../hooks/useLandingPageEmailParam';

const HomePageMobilePro = () => {
	const { t } = useTranslation();
	const {
		handleUserAuthentication,
		loadingSignin,
	} = useAuthContext();
	const {
		initialEmailFromQueryParam,
		hasValidEmailQueryParam,
		consumeEmailQueryParam,
	} = useLandingPageEmailParam();
	const [email, setEmail] = useState(initialEmailFromQueryParam);
	const [isPro, setIsPro] = useState(true);
	const navigate = useNavigate();
	
	useEffect(() => {
		if (!isPro) {
			const timer = setTimeout(() => {
				navigate('/part');
			}, 300);
			
			return () => clearTimeout(timer);
		}
	}, [isPro, navigate]);

	useEffect(() => {
		if (!hasValidEmailQueryParam) {
			return;
		}

		consumeEmailQueryParam();
		handleUserAuthentication(initialEmailFromQueryParam, UserType.PRO);
	}, [
		consumeEmailQueryParam,
		handleUserAuthentication,
		hasValidEmailQueryParam,
		initialEmailFromQueryParam,
	]);
	
	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		handleUserAuthentication(email, UserType.PRO);
	};
	
	return (
		<div style={{ width: 390 }}>
			<div
				style={{
					width: 362,
					height: 406,
					margin: '0 14px',
					background: '#ECECEC',
					borderRadius: 10,
					position: 'relative',
				}}
			>
				<div
					style={{
						position: 'absolute',
						width: 302,
						height: 26,
						top: 21,
						left: 31,
						background: '#FF4D00',
						color: '#FFFFFF',
						letterSpacing: 0,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<div style={{
						marginTop: '-1px',
						fontSize: 18,
						fontWeight: 'bold'
					}}>
						{t('page1:welcome')}
					</div>
				</div>
				
				<SwitchMobile isPro={isPro} setIsPro={setIsPro} positionTop={68} />
				
				<form
					onSubmit={handleSubmit}
					style={{
						position: 'absolute',
						top: 136,
						left: 30,
						width: 303,
						height: 244,
						background: '#FFFFFF',
						boxShadow: '0px 1px 6px #0F4D0029',
						borderRadius: 10,
					}}
				>
					<div style={{ position: 'relative' }}>
						<div
							style={{
								position: 'absolute',
								top: 27,
								textAlign: 'center',
								fontWeight: 'bold',
								fontSize: 16,
								width: '100%',
								display: 'flex',
								justifyContent: 'center',
							}}
						>
							{t('page1:login_signup')}
						</div>
						<div
							style={{
								position: 'absolute',
								top: 55,
								left: 107,
								width: 87,
								height: 2,
								background: '#FF4D00',
							}}
						/>
						<div
							style={{
								position: 'absolute',
								top: 78,
								fontWeight: 500,
								fontSize: 12,
								width: '90%',
								padding: '0 5%',
								display: 'flex',
								textAlign: 'center',
							}}
						>
							{t('page1:enter_email')}
						</div>
						
						<div
							style={{
								position: 'absolute',
								top: 140,
								left: 20,
							}}
						>
							<TextInputMobile
								width={265}
								type="email"
								startIcon="@"
								placeholder="jean.dupont@gmail.com"
								value={email}
								onChange={(e) => setEmail(e.target.value.toLowerCase())}
								loading={loadingSignin}
							/>
						</div>
						
						<button
							type="submit"
							style={{
								position: 'absolute',
								top: 192,
								left: '50%',
								transform: 'translateX(-50%)',
								padding: '0px 20px',
								minHeight: 27,
								height: 'auto',
								borderRadius: 5,
								backgroundColor: '#FF4D00',
								color: '#FFFFFF',
								border: 'none',
								fontSize: 14,
								fontWeight: 600,
								cursor: 'pointer',
								textTransform: 'uppercase',
								fontFamily: 'Montserrat, sans-serif',
								whiteSpace: 'nowrap',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							{t('page1:button_text')}
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default HomePageMobilePro;
